import type { TranslationKeysError } from '../localeType';

export const daDK_error: TranslationKeysError = {
  error: 'Fejl:',
  // Update ORDER
  ORDER_NOT_FOUND: `Ordren blev ikke fundet`,
  ORDER_SUSPENDED: `Ordren er suspenderet`,
  ORDER_IN_USE: `Ordren er allerede i brug`,
  FLORIST_NOT_FOUND: `Blomsterhandlerens identifikator blev ikke fundet`,
  NOTIFICATION_CHANNEL_EMPTY: `Der opstod en fejl i systemet`,
  UPDATE_NOT_ALLOWED_WRONG_STATUS: `Ordren kan ikke opdateres til denne status`,
  UPDATE_NOT_ALLOWED_WRONG_EXECUTOR: `Ordren kan ikke opdateres af brugeren`,
  UPDATE_KO: `Ordrestatus er blevet opdateret, men der er en fejl relateret til fakturering, som skal kontrolleres`,
  EXCEPTION: `Ordren kan ikke opdateres. Der opstod en fejl.`,
  UNKNOWN_EXCEPTION: `Ordren kan ikke opdateres. Der opstod en fejl.`,
  OrderNotFoundException: `Ordren blev ikke fundet i systemet`,
  IncorrectOrderActionException: `Den anmodede handling understøttes ikke`,
  OrderStatusNotConsistentException: `Den nye status, der anmodes om på ordren, er ikke mulig`,
  InvariantException: `Teknisk fejl i systemet: HTTP BAD REQUEST`,
  // POST ORDER
  IncorrectBodyModelException: `Transmission mislykkedes: Intern fejl - Fejlkode: PO-01`,
  IncorrectOrderException: `Transmission mislykkedes: Intern fejl - Fejlkode: PO-02`,
  BadRequestException: `Transmission mislykkedes: Intern fejl - Fejlkode: PO-03`,
  Exception: `Transmission mislykkedes: Intern fejl - Fejlkode: PO-04`,
  FeasabilityExceptionRaoKo: 'Transmission mislykkedes: Intern fejl - Fejlkode: PO-05',
  FeasabilityExceptionRaoResponseDataKo: `Transmission mislykkedes: Intern fejl - Fejlkode: PO-06`,
  FeasabilityExceptionEmptyFlorists: '`Transmission mislykkedes: Intern fejl - Fejlkode: PO-07`',
  PersonalCodeExceptionPersonalCodeNotFound: `Transmission mislykkedes: Intern fejl - Fejlkode: PO-08`,
  PersonalCodeExceptionExecutingFloristMismatch: `Transmission mislykkedes: Intern fejl - Fejlkode: PO-09`,
  ValidationException: 'Ordrevalidering mislykkedes (manglende felter) - Fejlkode: PO-10',
  PersonalCodeNeededPsm: 'Forudgående godkendelse kræves for tilpasset produkt (PSM) - Fejlkode: PO-11',
  PersonalCodeNeededXProduct: 'Forudgående godkendelse kræves for produkt med kode der slutter på X - Fejlkode: PO-12',
  PersonalCodeNeededPrice: 'Prisen overstiger ekstra stor størrelse, godkendelseskode kræves - Fejlkode: PO-12',
  PersonalCodeNeededPreparationTime: 'Forudgående godkendelse kræves, forberedelsestiden er for kort - Fejlkode: PO-13',
  PersonalCodeNeededHourLimit:
    'Forudgående godkendelse kræves, leveringstiden er for kort for det valgte tidspunkt - Fejlkode: PO-14',
  SelectedExecutingFloristNotFound: `Udførende blomsterhandler ikke fundet - Fejlkode: PO-15`,
  UpdatePersonalCodeKO: 'Umuligt at opdatere AP-koden, da den allerede er i brug.',
  // LOGIN
  loginError: {
    floristUnknown: {
      title: `Blomsterhandlerens login blev ikke fundet.`,
      body: `Klik venligst på knappen "Log ud".`,
    },
    noCountryCode: {
      title: `Blomsterhandlerens landekode blev ikke fundet.`,
      body: `Klik venligst på knappen "Log ud".`,
    },
    logoutButton: 'Log ud',
  },
};
